module.exports = __webpack_public_path__ + "static/media/costco-uk.7b696578.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/costco-uk.png
// module id = 1311
// module chunks = 0